import { isString } from "lodash";
import { type Currency, resolveCurrency } from "@orie/sdk";

export const getCurrencyRepresentation = (
  currency: Currency | string
): string => {
  const c = isString(currency) ? currency : currency.code;

  const code = match(String(c).toUpperCase(), {
    AUD: "A",
    USD: "US",
    CAD: "CA",
    EUR: "EU",
    default: c,
  });

  const symbol = isString(currency)
    ? resolveCurrency(currency)?.symbol || ""
    : currency.symbol;

  return code + symbol;
};
